import auth from '../../middlewares/auth';

export const scheduleRoutes = [
  {
    path: '/schedules/all',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/schedules/ScheduleList'
      ),
    name: 'schedules-all',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/schedules/calender',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/schedules/ScheduleCalender'
      ),
    name: 'schedules-calender',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/schedule/:id',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/schedules/ScheduleForm'
      ),
    name: 'update-schedule',
    meta: {
      middleware: [auth],
    },
  },
  {
    path: '/create-schedule',
    component: () =>
      import(
        /* webpackChunkName: "schedules" */ '../../views/schedules/ScheduleForm'
      ),
    name: 'create-schedule',
    meta: {
      middleware: [auth],
    },
  },
];
